import type { ConversationNodeClose } from 'lib-shared-types-api';

type RoutedThroughCloseProps = {
  node: ConversationNodeClose;
};

export function RoutedThroughClose(_: RoutedThroughCloseProps): JSX.Element {
  return <>Close conversation</>;
}
